export default "__VITE_ASSET__1B9IydNB__"